import DestinationTag from 'components/DestinationTag'
import Link from 'components/Link'
import Headers from 'components/home/common/typography/Headers'
import Paragraphs from 'components/home/common/typography/Paragraphs'
import ShareIcons from 'components/magazines/ShareIcons'
import { RestArticle } from 'data/types/article'
import React from 'react'

interface ArticleHeaderProps {
  article: RestArticle
}

const ArticleHeader = ({ article }: ArticleHeaderProps) => {
  return (
    <div>
      <hr className="hidden text-grey-200 lg:block" />
      <div className="flex flex-col lg:flex-row max-w-[1800px] mx-auto">

        <div
          className="h-[260px] lg:h-[700px] w-full xl:max-w-[992px] bg-grey-250 bg-opacity-30 bg-no-repeat bg-center bg-cover" style={{
            backgroundImage: `url(${article?.thumbnail?.src})`,
          }}
        />

        <div className="max-w-[800px] px-20 lg:pl-[80px] lg:pr-50 py-75 lg:py-100 mx-auto">
          <div className="max-w-[546px]">

            <Paragraphs.LG className="mb-20 font-bold uppercase text-grey-750">
              {article?.created_at}
            </Paragraphs.LG>

            <Headers.Title
              className="mb-20 text-grey-900"
              dangerouslySetInnerHTML={{ __html: article?.title }}
            />

            <div
              className="max-w-[458px] text-14 text-grey-750 leading-22 mb-20"
              dangerouslySetInnerHTML={{ __html: article?.excerpt }}
            />

            <Paragraphs.LG className="text-grey-500 mb-[28px]">
              By <Link className="underline" href={'/magazine/authors/' + article?.author?.slug}>{article?.author?.name}</Link>
            </Paragraphs.LG>

            <DestinationTag destination={article?.destination} />

            <div className="flex flex-col gap-14">
              <Paragraphs.MD className="mt-20 font-bold uppercase text-grey-800 tracking-1/2">
                Share
              </Paragraphs.MD>

              <ShareIcons article={article} />
            </div>

          </div>
        </div>
      </div>

      <hr className="hidden text-grey-200 lg:block" />

    </div>
  )
}

export default ArticleHeader
